export default "__VITE_ASSET__Fj9ink_Y__"